import { render, staticRenderFns } from "./Pharmacies.vue?vue&type=template&id=19bbd8e0"
import script from "./Pharmacies.vue?vue&type=script&lang=js"
export * from "./Pharmacies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports